<template>
    <div class="mt-4 mb-5">
        <div class="container">
            <div class="d-flex flex-wrap justify-content-around">
                <div class="col-12 col-md-12 col-lg-12">
                    <h1>{{ $t('cart.change_payment') }}</h1>
                    <card
                        type="secondary"
                        shadow
                        header-classes="bg-secondary"
                        body-classes="px-lg-12 py-lg-12"
                        class="border-0"
                        style="margin-bottom: 0"
                    >
                        <div class="col-12">
                            <base-radio
                                name="credit_card"
                                class="mb-3"
                                v-model="payment_method"
                                v-if="
                                    data.slug === 'pagseguro' ||
                                    data.slug === 'cielo' ||
                                    data.slug === 'cielo-jmv'
                                "
                            >
                                {{ $t('common.credit_card') }}
                            </base-radio>
                            <base-radio
                                name="debit_card"
                                class="mb-3"
                                v-model="payment_method"
                                v-if="!data.recurrence_id"
                            >
                                {{ $t('common.debit_card') }}
                            </base-radio>
                        </div>
                        <change-payment-billet
                            ref="billet"
                            v-model="payment"
                            v-if="
                                payment_method === 'billet' &&
                                (data.slug !== 'cielo' ||
                                    data.slug !== 'cielo-jmv' ||
                                    data.slug !== 'pagseguro')
                            "
                            :color="color"
                        />
                        <change-payment-credit-card
                            ref="credit_card"
                            v-model="payment"
                            :creditCardGateway="creditDebitGateways"
                            v-if="
                                payment_method === 'credit_card' &&
                                (data.slug === 'cielo' ||
                                    data.slug === 'cielo-jmv' ||
                                    data.slug === 'pagseguro')
                            "
                            :slug="data.slug"
                            :color="color"
                            v-on:validate="validateAll"
                        />
                        <template v-if="data.slug === 'pagseguro'">
                            <change-payment-document v-model="payment" />
                            <change-payment-form
                                ref="payment_form"
                                v-model="payment"
                                :slug="data.slug"
                                :color="color"
                                v-on:validate="validateAll"
                            />
                        </template>
                        <change-payment-debit-card
                            ref="debit_card"
                            v-model="payment"
                            v-if="
                                payment_method === 'debit_card' &&
                                (data.slug === 'cielo' ||
                                    data.slug !== 'cielo-jmv' ||
                                    data.slug !== 'pagseguro')
                            "
                            :slug="data.slug"
                            :color="color"
                            v-on:validate="validateAll"
                        />
                        <div class="d-flex justify-content-between">
                            <div
                                class="col-md-6 pl-0"
                                :class="$mq === 'sm' ? 'pr-0 mb-2' : ''"
                            >
                                <a
                                    :href="
                                        data.recurrence_id
                                            ? `/app/financial/recurrence/${data.recurrence_id}`
                                            : '/cart'
                                    "
                                    class="btn btn-warning"
                                >{{ $t('common.back') }}</a>
                            </div>
                            <div
                                class="col-md-6 pr-0"
                                :class="$mq === 'sm' ? 'pr-0 mb-2' : ''"
                                v-if="data.recurrence_id"
                            >
                                <button
                                    @click="pay"
                                    class="btn btn-success btn-block"
                                    :title="$t('billing.recurrence.link_payment')"
                                >
                                    {{ $t('billing.recurrence.link_payment') }}
                                </button>
                            </div>
                            <div
                                class="col-md-6 pr-0"
                                :class="$mq === 'sm' ? 'pr-0 mb-2' : ''"
                                v-else
                            >
                                <button
                                    @click="pay"
                                    :disabled="!valid"
                                    class="btn btn-success btn-block"
                                    :title="$t('cart.pay')"
                                >
                                    {{ $t('cart.pay') }}
                                </button>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Tabs from '../../argon/components/Tabs/Tabs';
import TabPane from '../../argon/components/Tabs/Tab';
import Card from '../../argon/components/Cards/Card';
import BaseInput from '../../argon/components/Inputs/BaseInput';
import BaseButton from '../../argon/components/BaseButton';
import BaseRadio from '../../argon/components/Inputs/BaseRadio';
import Modal from '../../argon/components/Modal';

import ChangePaymentBillet from './ChangePaymentBillet';
import ChangePaymentCreditCard from './ChangePaymentCreditCard';
import ChangePaymentDebitCard from './ChangePaymentDebitCard';
import ChangePaymentForm from './ChangePaymentForm';
import ChangePaymentDocument from './ChangePaymentDocument';

export default {
    name: 'ChangePayment',
    components: {
        Tabs,
        TabPane,
        BaseButton,
        BaseInput,
        BaseRadio,
        Card,
        ChangePaymentBillet,
        ChangePaymentCreditCard,
        ChangePaymentDebitCard,
        ChangePaymentForm,
        ChangePaymentDocument,
        Modal,
    },
    props: {
        invoiceId: String,
        data: {
            type: Object,
            required: true,
        },
        color: {
            type: Object,
            required: true,
        },
        gateways: Array,
    },
    data() {
        return {
            payment: {
                number: '',
                address: {
                    location: {
                        zip: '',
                        address: '',
                        number: '',
                        neighborhood: '',
                        country: '',
                        state: '',
                        city: '',
                        info: '',
                    },
                },
            },
            valid: false,
            payment_token: false,
            resetDialog: false,
            payment_method:
                this.data.slug === 'cielo' ||
                this.data.slug === 'cielo-jmv' ||
                this.data.slug === 'pagseguro'
                    ? 'credit_card'
                    : 'billet',
        };
    },

    computed: {
        creditDebitGateways() {
            // Filter the gateways where the name is "Crédito / Débito"
            return this.gateways.filter(gateway => gateway.name === 'Crédito / Débito');
        },
    },

    methods: {
        /**
         * Mensagem de erro do pagamento: usa a explicação devolvida pelo
         * servidor (bandeira não identificada, recusa do gateway, fatura
         * pendente, cobrança cancelada...) e só cai no texto genérico quando
         * não há resposta — antes tudo virava "Falha ao finalizar compra" e o
         * aluno repetia a compra às cegas (backlog#338).
         *
         * @param {Object} error erro do axios
         * @returns {string}
         */
        paymentErrorMessage(error) {
            const serverMessage = error && error.response && error.response.data
                ? error.response.data.error
                : null;

            return typeof serverMessage === 'string' && serverMessage.trim() !== ''
                ? serverMessage
                : this.$t('common.payment_error');
        },
        getUrl() {
            let url = '';
            // rota para o checkout padrão do carrinho
            if (this.invoiceId) {
                url = `/api/app/invoices/${Number(this.invoiceId)}/pay`;
            } else {
                url = '/api/app/checkout/finish';
            }
            if (this.data.recurrence_id) {
                url = `/api/app/recurrences/${this.data.recurrence_id}/associate/gateway`;
            }
            return url;
        },

        // pagamento via boleto do gerencia net
        payBillet() {
            const { phone_number: phone, birth } = this.payment;
            const { plan, slug, bank, id, recurrence_id: recurrence } = this.data;

            window.axios
                .post(this.getUrl(), {
                    plan,
                    slug,
                    bank,
                    id,
                    recurrence_id: recurrence,
                    changed: true,
                    phone_number: phone,
                    birth,
                    payment_method: this.payment_method,
                })
                .then((res) => {
                    location.href = res.data.url;
                })
                .catch((error) => {
                    this.$loading.close();
                    this.$notify({
                        type: 'danger',
                        message: this.paymentErrorMessage(error),
                    });
                });
        },

        // recorrencia gerencia-net cartão de credito, boleto e debito
        payGerenciaNet() {
            this.requestPaymentToken((e, response) => {
                if (e) {
                    this.$notify({
                        type: 'danger',
                        message: e.error_description,
                    });

                    this.$loading.close();
                } else {
                    this.payment_token = response.data.payment_token;

                    const {
                        brand,
                        cvv,
                        number,
                        birth,
                        phone_number: phone,
                        expiration_month: month,
                        expiration_year: year,
                    } = this.payment;
                    const {
                        plan,
                        slug,
                        bank,
                        id,
                        recurrence_id: recurrence,
                    } = this.data;

                    window.axios
                        .post(this.getUrl(), {
                            plan,
                            slug,
                            bank,
                            id,
                            recurrence_id: recurrence,
                            changed: true,
                            phone_number: phone,
                            brand,
                            cvv,
                            number,
                            expiration_month: month,
                            expiration_year: year,
                            birth,
                            payment_token: this.payment_token,
                            payment_method: this.payment_method,
                        })
                        .then((res) => {
                            location.href = res.data.url;
                        })
                        .catch((error) => {
                            this.$loading.close();
                            this.$notify({
                                type: 'danger',
                                message: this.paymentErrorMessage(error),
                            });
                        });
                }
            });
        },

        // pagamento via cartão de credito debito cielo/cielo-jmv
        payCielo() {
            const {
                holder,
                brand,
                cvv,
                number,
                expiration_month: month,
                expiration_year: year,
            } = this.payment;
            const { slug, bank, recurrence_id: recurrence, id, installment } = this.data;

            window.axios
                .post(this.getUrl(), {
                    slug,
                    bank,
                    id,
                    recurrence_id: recurrence,
                    changed: true,
                    type: this.payment_method,
                    holder,
                    brand,
                    cvv,
                    number,
                    expiration_month: month,
                    expiration_year: year,
                    installment,
                })
                .then((res) => {
                    location.href = res.data.url;
                })
                .catch((error) => {
                    this.$loading.close();
                    this.$notify({
                        type: 'danger',
                        message: this.paymentErrorMessage(error),
                    });
                });
        },

        // pagamento via cartão de credito debito pagseguro
        payPagseguro() {
            const {
                holder,
                brand,
                cvv,
                number,
                expiration_month: month,
                expiration_year: year,
                phone_number: phone,
                area_code: areaCode,
                document_type: documentType,
                document,
                birth,
                address,
            } = this.payment;
            const { slug, bank, recurrence_id: recurrence, id } = this.data;

            window.axios
                .post(this.getUrl(), {
                    slug,
                    bank,
                    id,
                    changed: true,
                    holder,
                    brand,
                    cvv,
                    number,
                    birth,
                    recurrence_id: recurrence,
                    type: this.payment_method,
                    expiration_month: month,
                    expiration_year: year,
                    area_code: areaCode,
                    phone_number: phone,
                    document,
                    document_type: documentType,
                    address: JSON.stringify(address),
                })
                .then((res) => {
                    location.href = res.data.url;
                })
                .catch((error) => {
                    this.$loading.close();
                    this.$notify({
                        type: 'danger',
                        message: this.paymentErrorMessage(error),
                    });
                });
        },

        // pagamento via cartão de crédito
        pay() {
            this.$loading.show();

            this.$refs[this.payment_method].$validator
                .validateAll()
                .then((valid) => {
                    if (!valid) {
                        this.$loading.close();
                        this.$notify({
                            type: 'danger',
                            message: this.$t('validation.err'),
                        });
                        return;
                    }
                    this.payment.number = this.payment.number.replace(/\s/g, '');

                    if (this.data.slug === 'gerencia-net') {
                        if (this.payment_method === 'billet') {
                            this.payBillet();
                        } else {
                            this.payGerenciaNet();
                        }
                    } else if (
                        this.data.slug === 'cielo' ||
                        this.data.slug === 'cielo-jmv'
                    ) {
                        this.payCielo();
                    } else if (this.data.slug === 'pagseguro') {
                        this.$refs.payment_form.$validator
                            .validateAll()
                            .then((isValid) => {
                                if (!isValid) {
                                    this.$loading.close();
                                    this.$notify({
                                        type: 'danger',
                                        message: this.$t('validation.err'),
                                    });
                                    return;
                                }
                                this.payPagseguro();
                            });
                    }
                });
        },
        validateAll() {
            this.$refs[this.payment_method].$validator
                .validateAll()
                .then((isValid) => {
                    this.valid = isValid;
                });
        },
        // pega o token de autorização para o pagamento via cartão de crédito
        async requestPaymentToken(cb) {
            return window.$gn.checkout.getPaymentToken(
                {
                    brand: this.payment.brand, // bandeira do cartão
                    number: this.payment.number, // número do cartão
                    cvv: this.payment.cvv, // código de segurança
                    expiration_month: this.payment.expiration_month, // mês de vencimento
                    expiration_year: this.payment.expiration_year, // ano de vencimento
                },
                (error, response) => cb(error, response),
            );
        },
    },
};
</script>
